import React from 'react';
import { styles } from './ThumbnailIconCarousel.css';
import { Carousel } from '@jbhi-fi/lanyard-ui/components/Carousel';
import { ThumbnailIcon, ThumbnailIconProps } from '../ThumbnailIcon/ThumbnailIcon';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { GoToLink, GoToLinkProps } from '../GoToLink/GoToLink';
import { ListingBlockHeading } from '../ListingBlock/ListingBlockHeading';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { ContentThemePalette } from '../Contentful/transformers/ThemeTransformer';
import { TrackingProvider } from '../Tracking';

export type ThumbnailIconCarouselProps = {
  title: string;
  thumbnails: Array<ThumbnailIconProps>;
  palette?: ContentThemePalette;
  linkProps?: Omit<GoToLinkProps, 'className'>;
};

export const ThumbnailIconCarousel = ({
  title,
  thumbnails = [],
  linkProps,
  palette: paletteProp,
}: ThumbnailIconCarouselProps) => {
  const isDesktop = useBreakpoint('md', 'up');
  const {
    text: textColor = palette.primary.dark,
    heading: headingColor = palette.primary.dark,
    background: backgroundColor = palette.primary.light,
  } = paletteProp ?? {};

  return (
    <TrackingProvider shouldInheritFromParentContexts group={title}>
      <div
        className={styles.thumbnailIconCarouselContainer}
        style={{ color: textColor }}
        data-testid="thumbnail-icon-carousel"
      >
        <ListingBlockHeading
          heading={title}
          headingAs="h3"
          headingClassName={styles.title}
          headingColor={headingColor}
        />
        <Carousel
          slidesPerView="auto"
          slidesPerGroup={isDesktop ? 3 : 2}
          showPagination={false}
          spaceBetween={0}
          rewind
          arrowColor={textColor}
          fullBleed={!isDesktop}
          slidesOffsetBefore={-20}
          showArrows={true}
          arrowPosition="bottom"
        >
          {thumbnails.map((thumbnail, i) => (
            <ThumbnailIcon key={i} {...thumbnail} />
          ))}
        </Carousel>
        {linkProps?.href ? <GoToLink {...linkProps} className={styles.link} /> : null}
      </div>
    </TrackingProvider>
  );
};
